import React from "react";
import clsx from "clsx";
import { useTranslation } from "react-i18next";
import moment from "moment";
import Alert from "components/Alert";
import Tooltip from "components/Tooltip";

const CertificationHeader = (props: {
  logo?: string;
  name?: string;
  isComplete?: boolean;
  hasData?: boolean;
  modifiedDate?: string;
}) => {
  const { t, i18n } = useTranslation();
  const isEng = i18n.language === "en";

  const getStatus = () => {
    if (props.isComplete) {
      return t("operationalEnergy.completeState", {
        date: moment(props.modifiedDate).format(
          isEng ? "DD.MM.YYYY, hh:mm A" : "DD.MM.YYYY, HH:mm"
        ),
      });
    } else if (props.hasData) {
      return (
        <Tooltip content={t("operationalEnergy.notCompleteDataTooltip")}>
          {t("operationalEnergy.notCompleteData", {
            date: moment(props.modifiedDate).format(
              isEng ? "DD.MM.YYYY, hh:mm A" : "DD.MM.YYYY, HH:mm"
            ),
          })}
        </Tooltip>
      );
    } else {
      return (
        <Tooltip content={t("operationalEnergy.notCompleteTooltip")}>
          {t("operationalEnergy.emissionsMissing")}
        </Tooltip>
      );
    }
  };

  return (
    <div className="flex items-center w-full justify-between">
      <div className="flex items-center w-full">
        <img src={props?.logo} alt="cert-logo" className="mr-3" />
        <div className="text-sm font-medium truncate mr-2">{props?.name}</div>
        <div
          className={clsx(
            "flex items-center justify-center text-xs px-2",
            "h-[23px] rounded-full",
            props.isComplete
              ? "bg-green-100 text-green-700"
              : "bg-yellow-100 text-yellow-700"
          )}
        >
          {getStatus()}
        </div>
      </div>
      {!props.isComplete && !props.hasData && (
        <Alert
          type="info"
          className="!p-0 bg-transparent border-none whitespace-nowrap mr-0"
          title={t("operationalEnergy.inCompleteAlert")}
        />
      )}
    </div>
  );
};

export default CertificationHeader;
